// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_Qe","wrapperDark":"e_Re","wrapperLight":"e_Se"};